import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import {
  routerMiddleware,
  connectRouter,
  ConnectedRouter
} from 'connected-react-router';
import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './redux/rootReducer';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import App from './App';
import './styles/BaseStyles';
import * as startThunk from './redux/startThunk';
import client from './infra/http/AxiosClient';

const history = createBrowserHistory();

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  connectRouter(history)(rootReducer),
  composeEnhancer(applyMiddleware(routerMiddleware(history), thunk))
);
client.setupInterceptores(store, history);
store.dispatch(startThunk.start());

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js